// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconDarkCanvasPath = 'M15.498 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.432 13.825a9.23 9.23 0 0 1-11.787 5.608 9.23 9.23 0 0 1 0-17.395l1.972-.7-.694 1.974a7.24 7.24 0 0 0 9.226 9.235l.16-.057h1.597l-.474 1.335Zm-3.156 1.115a9.234 9.234 0 0 1-3.59-.51c-4.09-1.438-6.53-5.462-6.134-9.592a7.23 7.23 0 1 0 9.93 10.286l.156-.212-.362.028ZM12.998 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z';
var IconDarkCanvas = baseIcon('IconDarkCanvas', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconDarkCanvasPath
});
export default IconDarkCanvas;
//# sourceMappingURL=index.js.map